export const visit = (vm, at) => {
at({ "nl": { "conversations-visitor-ui": { "pageTitleNotifications": { "newMessage": "Nieuw bericht" } }, "conversationsVisitorUIPageTitleNotifications": { "newMessage": "Nieuw bericht" } } });
};